import { onMounted, onUnmounted, nextTick } from 'vue'

let resizeHandler = null

export function useNavbarAlignment () {
  const updateAlignment = () => {
    if (window.innerWidth < 1280) {
      document.documentElement.style.setProperty('--content-padding-left', '')
      document.documentElement.style.setProperty('--content-padding-right', '')
      return
    }

    const logo = document.querySelector('[data-navbar-logo]')
    const avatar = document.querySelector('[data-navbar-avatar]')

    if (logo && avatar) {
      const logoRect = logo.getBoundingClientRect()
      const avatarRect = avatar.getBoundingClientRect()

      document.documentElement.style.setProperty(
        '--content-padding-left',
        `${logoRect.left}px`
      )
      document.documentElement.style.setProperty(
        '--content-padding-right',
        `${window.innerWidth - avatarRect.left}px`
      )
    }
  }

  onMounted(async () => {
    await nextTick()
    updateAlignment()

    resizeHandler = () => {
      requestAnimationFrame(updateAlignment)
    }
    window.addEventListener('resize', resizeHandler)

    setTimeout(updateAlignment, 100)
    setTimeout(updateAlignment, 300)
  })

  onUnmounted(() => {
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler)
      resizeHandler = null
    }
  })
}
